import { toast } from "react-toastify";
import {
  fetchCreateAdjustmentRequest,
  fetchCreateAdjustmentSuccess,
  fetchCreateAdjustmentFailure,
} from "./reducer";

import { CREATE_ADJUSTMENT } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";

export const createAdjustment =
  (referenceId, jsonObj, setLoading, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchCreateAdjustmentRequest());

    setLoading(true);

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        CREATE_ADJUSTMENT(referenceId),
        "POST",
        jsonObj
      );

      if (response?.error) {
        dispatch(fetchCreateAdjustmentFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchCreateAdjustmentSuccess(response));
        dispatch(setSuccessMessage(true));
        toast.success("Product quantity adjusted successfully");
        onSuccess && onSuccess();
      }
    } catch (error) {
      dispatch(fetchCreateAdjustmentFailure("Something went wrong"));
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };